import { Result } from "../../models/result";

export function sortSizeAscending(a: Result, b: Result) {
	if (a === undefined || b === undefined) {
		return 0;
	}

	if (a.size[0] < b.size[0]) {
		return -1;
	}
	if (a.size[0] > b.size[0]) {
		return 1;
	}

	return 0;
}
